import SalesOffice from './SalesOffice'
import Feature from './Feature'

export class User {
    ID: number;
    Username: string;
    Password: string;
    FirstName: string;
    LastName: string;
    FullName?: string;
    PersonnelNumber: string;
    PhoneNumber: string;
    SalesOfficeID: number;
    SalesOffice: SalesOffice;
    Features: Feature[];
}

export default User;